import { useDispatch } from "react-redux";
import { closeModal } from "../../../features/modalSLice";
import { useNavigate } from "react-router-dom";
import { Save, Trash2 } from "lucide-react";
import { loadStatus } from "../../../util";

const SubmitButton = ({ loading, red, submitText }) => {
  return (
    <div className="flex justify-between items-center py-7">
      <button
        type="submit"
        disabled={loading === loadStatus.loading}
        className={`${red ? "delete-rss-btn" : "add-rss-btn"} `}
      >
        {(submitText && submitText?.toLowerCase() === "delete") || red ? (
          <Trash2 size={18} />
        ) : (
          <Save size={18} />
        )}
        {submitText ? submitText : "Submit"}
      </button>
    </div>
  );
};

export default SubmitButton;
